module.exports = __webpack_public_path__ + "static/media/ad-05.69b0bbbb.jpg";